module.exports = __webpack_public_path__ + "52c9289f.png";